export const reduxResourceContexts = {
  delete: "delete"
};
